// @flow

import { call, takeEvery, put } from 'redux-saga/effects';
import { type Saga } from 'redux-saga';
import { makePutRequest } from 'services/request/request';
import { fetchAllLogsRequest } from 'redux/Machine/actions';
import { CARD_LOGS_UPDATE_REQUEST } from './constant';
import { cardLogsUpdateFailure, cardLogsUpdateSuccess } from './actions';

export function* cardLogsUpdateRequest(data: any): Saga<*> {
  try {
    const {
      payload: { id, guardAction, lotNumber },
    } = data;
    const response = yield call(makePutRequest, `/card/${id}/${guardAction}`);
    if (response && response.statusCode === 202) {
      yield put(cardLogsUpdateSuccess());
      yield put(fetchAllLogsRequest('guard-logs', lotNumber));
    }
  } catch (error) {
    yield put(cardLogsUpdateFailure({ statusCode: error.statusCode, message: error.message }));
  }
}

export default function* pitSaga(): Saga<*> {
  yield takeEvery(CARD_LOGS_UPDATE_REQUEST, cardLogsUpdateRequest);
}
